import { Stack } from "@mui/material";
import { type GetContactsResponse } from "@repo/api";
import { cs, HeadingL } from "@repo/ui";
import { type FC } from "react";
import InformationList from "../InformationList";
import { EmailLink } from "../Link/ContactLink";


const Consultants: FC<{
	consultants: GetContactsResponse[];
}> = ({ consultants }) => {
	return (
		<>
			{consultants.length > 0 && (
				<>
					<HeadingL>Moji poradci</HeadingL>
					<Stack spacing={5} mb={6}>
						{consultants.map((contact, i) => (
							<InformationList
								key={i}
								title={contact.productName}
								information={[
									contact.name !== null && {
										title: cs.global.consultant,
										description: contact.name,
									},
									contact.email !== null && {
										title: cs.global.email,
										description: (
											<EmailLink email={contact.email} key="email" />
										),
									},
								]}
							/>
						))}
					</Stack>
				</>
			)}
		</>
	);
};
export default Consultants;
